<template lang="pug" src="./custom-home-instagram.pug"></template>

<script>
import { trigger } from '@/shared/functionality/mixins'
import api from '../../../shared/api/api'
import axios from 'axios'

export default {
  props: ['props'],
  mixins: [trigger],
  data () {
    return {
      instagram: null
    }
  },
  async created () {
    try {
      const res = await axios.get(`${api}/rg-instagram/v1/get-photos`)
      this.instagram = res.data
      console.log(this.instagram)
    } catch (error) {
      console.error(error)
    }
  }
  // computed: {
  //   feed () {
  //     return this.$store.state.instagram
  //   }
  // }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/custom-home-instagram/custom-home-instagram.vue